import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ar from './ar.json';
import en from './en.json';
import { LANG_STORAGE_KEY } from '@/utils/constants';
import type { Lang } from '@/types';

const stored = (typeof localStorage !== 'undefined' && localStorage.getItem(LANG_STORAGE_KEY)) as Lang | null;
const initial: Lang = stored === 'en' || stored === 'ar' ? stored : 'ar';

void i18n.use(initReactI18next).init({
  resources: {
    ar: { translation: ar },
    en: { translation: en },
  },
  lng: initial,
  fallbackLng: 'ar',
  interpolation: { escapeValue: false },
  returnNull: false,
});

function applyDocumentLang(lang: Lang) {
  if (typeof document === 'undefined') return;
  document.documentElement.lang = lang;
  document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
}

applyDocumentLang(initial);

i18n.on('languageChanged', (lng) => {
  const lang: Lang = lng === 'en' ? 'en' : 'ar';
  applyDocumentLang(lang);
  try { localStorage.setItem(LANG_STORAGE_KEY, lang); } catch { /* ignore */ }
});

export function setLanguage(lang: Lang): Promise<unknown> {
  return i18n.changeLanguage(lang);
}

export default i18n;
